export const ReferenceSkeletonItem = () => {
  return (
    <div className="col-span-1 flex w-full flex-col items-start justify-start gap-6">
      <div className="aspect-video w-full bg-neutral-100" />
      <div className="flex flex-col items-start justify-start gap-1">
        <div className="h-[30px] w-36 bg-neutral-100 sm:h-[36px] lg:h-[42px]" />
        <div className="h-[18px] w-16 bg-neutral-100 sm:h-[20px] lg:h-[24px]" />
      </div>
    </div>
  );
};
